module.exports = __webpack_public_path__ + "static/media/premise-logo.460ba9f7.svg";